export type PwaUpdateDetail = {
  reload: () => void
}

const PWA_UPDATE_EVENT = 'cse:pwa-update-available'

let listenerCount = 0
let pending: PwaUpdateDetail | null = null

export function emitPwaUpdateAvailable(detail: PwaUpdateDetail): void {
  if (typeof window === 'undefined') return
  // registerSW runs before React mounts: keep the update until the first listener subscribes
  if (listenerCount === 0) {
    pending = detail
    return
  }
  window.dispatchEvent(new CustomEvent<PwaUpdateDetail>(PWA_UPDATE_EVENT, { detail }))
}

export function onPwaUpdateAvailable(listener: (detail: PwaUpdateDetail) => void): () => void {
  if (typeof window === 'undefined') return () => undefined

  const handler = (event: Event) => {
    listener((event as CustomEvent<PwaUpdateDetail>).detail)
  }

  window.addEventListener(PWA_UPDATE_EVENT, handler)
  listenerCount += 1

  if (pending !== null) {
    const detail = pending
    pending = null
    listener(detail)
  }

  return () => {
    window.removeEventListener(PWA_UPDATE_EVENT, handler)
    listenerCount -= 1
  }
}
